import Container from "./Container";
import Text from "./Text";
import { normalizeAssetSource } from "../commons/assetSource";
import { IMPORTED_DIRPF_ASSET_SOURCE } from "../commons/dirpfImportMeta";

interface IAssetSourceIndicatorProps {
    /** `asset_source`, `vehicle_source` ou `property_source` conforme o tipo de ativo. */
    sourceRaw?: string | null;
    /** Se true, exibe rótulo textual ao lado do ícone (ex.: modal de detalhes). */
    showLabel?: boolean;
    className?: string;
}

export default function AssetSourceIndicator({ sourceRaw, showLabel, className }: IAssetSourceIndicatorProps) {
    const src = normalizeAssetSource(sourceRaw);
    const isDirpf = src === IMPORTED_DIRPF_ASSET_SOURCE;
    const title = isDirpf
        ? "Importado via declaração de IR (DIRPF)"
        : "Cadastro manual";

    return (
        <span title={title} className={className} role="img" aria-label={title}>
            <Container gap={2} itemsCenter className="flex-nowrap w-fit">
                <i
                    className={isDirpf ? "pi pi-file-import text-primary" : "pi pi-user text-600"}
                    style={{ fontSize: "1rem" }}
                    aria-hidden
                />
                {showLabel && (
                    <Text size="sm" color={isDirpf ? "primary" : "600"}>
                        {isDirpf ? "DIRPF / IR" : "Manual"}
                    </Text>
                )}
            </Container>
        </span>
    );
}
